<prox-main [parent]="this" [bodyTemplate]="bodyTemplate"></prox-main>
<ng-template #bodyTemplate>

  <div *ngIf="isPageReady && entities" class="h-full">

    <div class="flex flex-col h-full">
      <div class="qb-list-actions">
        <span class="qb-status-message">{{statusMessage()}}</span>
        <div class="grow"></div>
        <p-button *ngIf="hasHelp" (onClick)="showHelp()" [rounded]="true" [text]="true"
          icon="pi pi-question-circle"></p-button>
      </div>

      <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[40, 60]">
        <ng-template pTemplate>
          <div class="flex w-full h-full">
            <div class="w-1/2 h-full py-2">
              <prox-ag-grid [gridOptions]="gridOptions" [rowData]="entities"></prox-ag-grid>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate>
          <div class="py-2 w-full h-full">
            <div class="ml-4 mb-2 text-red-500" *ngIf="selectedRow && !selectedRow.accountId">Global roles cannot be
              edited.
              Add a new role if you need to change the rights.</div>
            <prox-role-rights-frm *ngIf="selectedRow" [proximityRole]="selectedRow" [areaId]="area" [allRights]="rights"
              [uow]="dbQueryService.uow" [isReadOnly]="!canEdit(selectedRow)"></prox-role-rights-frm>
          </div>
        </ng-template>
      </p-splitter>

      <div *ngIf="showSaveBar">
        <prox-save-cancel class="mt-2" [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()"
          [isReadOnly]="isAddDisabled()"></prox-save-cancel>
      </div>
    </div>

  </div>
</ng-template>